
import { UserIcon, Save, X } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ProfileContactForm } from "./ProfileContactForm";
import { AddressData } from "@/components/ui/AddressMapInput";

interface ProfileFormValues {
  displayName: string;
  phone: string;
  address: string;
  location: string;
  addressData: AddressData;
  emailBookingNotifications: boolean;
  smsBookingNotifications: boolean;
}

interface ProfileEditFormProps {
  form: UseFormReturn<ProfileFormValues>;
  loading: boolean;
  cancelEdit: () => void;
  handleSubmit: () => void;
}

export const ProfileEditForm = ({
  form,
  loading,
  cancelEdit,
  handleSubmit
}: ProfileEditFormProps) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <FormField
          control={form.control}
          name="displayName"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-2">
                <UserIcon className="h-4 w-4" />
                Display Name
              </FormLabel>
              <FormControl>
                <Input 
                  {...field}
                  placeholder="Enter your display name"
                  disabled={loading}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <ProfileContactForm
          form={form}
          loading={loading}
        />
      </div>
      
      {/* Action buttons at the bottom */}
      <div className="flex justify-end gap-2 pt-4 border-t">
        <Button 
          onClick={cancelEdit} 
          variant="outline" 
          size="sm"
          className="flex items-center gap-2"
        >
          <X className="h-4 w-4" />
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          size="sm"
          disabled={loading}
          className="flex items-center gap-2"
        >
          <Save className="h-4 w-4" />
          {loading ? "Saving..." : "Save Changes"}
        </Button>
      </div>
    </div>
  );
};
